import React, { useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { Quotation } from '../../types/quotation';
import { useOrganizations } from '../../hooks/useOrganizations';
import { useCustomers } from '../../hooks/useCustomers';
import { useProducts } from '../../hooks/useProducts';
import Modal from '../common/Modal';
import { format } from 'date-fns';
import {
  BuildingOffice2Icon,
  UserIcon,
  CalendarIcon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  ClockIcon,
  CheckBadgeIcon,
  ArrowDownTrayIcon
} from '@heroicons/react/24/outline';
import { formatAddress } from '../../utils/formatters';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import QuotationPdfContent from './QuotationPdfContent';
import { useLanguage } from '../../contexts/LanguageContext';
import HungarianQuotationPdfContent from './HungarianQuotationPdfContent';

interface QuotationPreviewProps {
  quotation: Quotation;
  isOpen: boolean;
  onClose: () => void;
}

const QuotationPreview: React.FC<QuotationPreviewProps> = ({ quotation, isOpen, onClose }) => {
  // const { organizations } = useOrganizations();
  // const { customers } = useCustomers();
  // const { products } = useProducts();

  // const organization = organizations?.find(org => org.id === quotation.organizationId);
  // const customer = customers?.find(c => c.id === quotation.customerId);
  // const quotationProducts = products?.filter(p =>
  //   quotation.items.some(item => item.productId === p.id)
  // );

  // const Content = quotation.language === 'en'
  //   ? QuotationPdfContent
  //   : HungarianQuotationPdfContent;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <div className="overflow-auto flex justify-center items-center">
        {/* <Content
          quotation={quotation}
          organization={organization}
          customer={customer}
          products={quotationProducts || []}
        /> */}
      </div>
    </Modal>
  );
};

export default QuotationPreview; 